'use client';

import { Breadcrumb, breadcrumbTag } from '@ni/nimble-components/dist/esm/breadcrumb';
import { wrap } from '../utilities/react-wrapper';

export { breadcrumbTag };
export { type Breadcrumb };
export const NimbleBreadcrumb = wrap(Breadcrumb);
